import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ButtonIcon from 'design-system/ButtonIcon/ButtonIcon';
import ArrowLeftSLineIcon from 'design-system/Icons/ArrowLeftSLineIcon';
import ArrowRightSLineIcon from 'design-system/Icons/ArrowRightSLineIcon';

TablePagination.propTypes = {
    data: PropTypes.shape({
        page: PropTypes.number.isRequired,
        limit: PropTypes.number.isRequired,
        totalItems: PropTypes.number.isRequired,
    }),
    onNextClick: PropTypes.func.isRequired,
    onPreviousClick: PropTypes.func.isRequired,
    variant: PropTypes.oneOf(['primary', 'secondary']),
};

function TablePagination(props) {
    const {
        data: { page, limit, totalItems: total },
        onNextClick,
        onPreviousClick,
        variant = 'primary',
    } = props;
    const start = (page - 1) * limit + 1;
    const end = page * limit > total ? total : page * limit;

    const previousDisabled = start === 1 ? 'disabled' : 'default';
    const nextDisabled = end === total ? 'disabled' : 'default';

    const containerClassNames = classNames(
        variant === 'secondary' && 'flex items-center justify-between gap-3 px-4 py-2'
    );
    const rightBarClassNames = classNames('flex items-center', {
        'gap-4': variant === 'primary',
        'gap-1.5': variant === 'secondary',
    });
    const labelClassName = classNames('font-body', {
        'text-body-regular-s text-black': variant === 'primary',
        'text-body-regular-xs text-neutral-300': variant === 'secondary',
    });
    const buttonType =
        {
            primary: 'ghost',
            secondary: 'neutral',
        }[variant] || 'ghost';

    return (
        <div className={containerClassNames}>
            {variant === 'secondary' && (
                <p className="font-body text-body-regular-xs text-neutral-300">
                    {total} record{total === 1 ? '' : 's'}
                </p>
            )}

            <div className={rightBarClassNames}>
                <p className={labelClassName}>{`${start}-${end} of ${total}`}</p>
                <div className="flex items-center gap-1">
                    <ButtonIcon
                        size="xs"
                        type={buttonType}
                        icon={ArrowLeftSLineIcon}
                        state={previousDisabled}
                        onClick={onPreviousClick}
                    />
                    <ButtonIcon
                        size="xs"
                        type={buttonType}
                        icon={ArrowRightSLineIcon}
                        state={nextDisabled}
                        onClick={onNextClick}
                    />
                </div>
            </div>
        </div>
    );
}

export default TablePagination;
